"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonUFA = void 0;
const get_screenshot_url_1 = require("../utils/get-screenshot-url");
const getIssueRules = (issues) => {
    const issuesByRuleId = {};
    issues.forEach(issue => {
        const ruleId = issue.id;
        if (issuesByRuleId[ruleId]) {
            issuesByRuleId[ruleId].count += issue.uniques.length;
            return;
        }
        issuesByRuleId[ruleId] = {
            count: issue.uniques.length,
            mode: 'automated'
        };
    });
    return Object.entries(issuesByRuleId).map(([ruleId, { count, mode }]) => ({
        name: ruleId,
        count,
        mode
    }));
};
const jsonUFA = (record, results, additionalProperties) => {
    const failedRules = getIssueRules(results.results);
    const startDate = record.created_at
        ? new Date(record.created_at).toISOString()
        : null;
    const endDate = record.updated_at
        ? new Date(record.updated_at).toISOString()
        : null;
    const axeVersion = record.axe_core_version;
    const bestPracticesEnabled = false;
    const experimentalEnabled = false;
    const exportData = {
        url: results.pageStateResults.length ? results.pageStateResults[0].url : '',
        extensionVersion: record.data_source_version || '',
        axeVersion,
        standard: additionalProperties.standard,
        testingStartDate: startDate,
        testingEndDate: endDate,
        bestPracticesEnabled,
        experimentalEnabled,
        issueSummary: {
            critical: results.overview.numIssueSeverity.critical.totalCurrent,
            minor: results.overview.numIssueSeverity.minor.totalCurrent,
            moderate: results.overview.numIssueSeverity.moderate.totalCurrent,
            serious: results.overview.numIssueSeverity.serious.totalCurrent,
            needsReview: 0,
            bestPractices: 0
        },
        remainingTestingSummary: {
            run: false
        },
        igtSummary: undefined,
        failedRules,
        needsReview: [],
        source: additionalProperties.source,
        testDetails: {
            testId: record.id,
            testName: record.name || '',
            createdBy: additionalProperties.createdBy || null,
            axeVersion: axeVersion || '',
            engine: additionalProperties.engine,
            standard: additionalProperties.standard,
            startDate,
            endDate,
            bestPracticesEnabled,
            experimentalEnabled,
            integrationTestId: additionalProperties.integrationTestId || null
        },
        allIssues: results.pageStateResults
            .map(pageStateResult => pageStateResult.result.map(issue => issue.uniques.map(uniqueIssue => ({
            issueId: null,
            ruleId: issue.id,
            description: issue.description,
            help: issue.help,
            helpUrl: issue.helpUrl,
            impact: issue.impact,
            needsReview: false,
            isManual: false,
            summary: issue.description,
            source: uniqueIssue.html,
            // TODO: This shouldn't be doing an "as string[]" cast.
            // See https://github.com/dequelabs/walnut/issues/8245
            selector: uniqueIssue.target,
            tags: issue.tags,
            testName: record.name,
            shareURL: null,
            createdAt: new Date(uniqueIssue.created_at).toISOString(),
            isExperimental: false,
            foundBy: record.user_email || undefined,
            testUrl: uniqueIssue.url,
            axeVersion,
            testPageTitle: uniqueIssue.page_state || undefined,
            integrationUrl: null,
            screenshotURL: (0, get_screenshot_url_1.getScreenshotUrl)(additionalProperties.baseScreenshotURL, uniqueIssue.screenshot_id)
        }))))
            .flat(3)
    };
    return JSON.stringify(exportData).replace(/\\n/g, '\\\\n');
};
exports.jsonUFA = jsonUFA;
//# sourceMappingURL=json-ufa.js.map